import React, { useState, useEffect } from 'react';
import _ from 'lodash';

import { getErrorValidateWithId } from '../../../utilities/works';
import CellContent from './CellContent';
import { Dropdown } from '../../dropdowns/portal';
import WorkScheduleService from '../../../services/Works';
import SessionStorageService from '../../../services/utilities/SessionStorageService';

const fieldId = SessionStorageService.getFieldId();

const OptionTemplate = ({
  grid,
  context,
  handlePushParam,
  msgValidate,
  column,
  isShowHistory = true,
  maxLength,
  tabKeyStatus,
}) => {
  const { isAbortedOrApproved } = context.item;
  const [option, setOption] = useState('');

  useEffect(() => {
    setOption(_.get(context, `item.${column}`, ''));
  }, [context.item[column]]);

  const handleUpdateData = (value, isSetState = false) => {
    if (isAbortedOrApproved) {
      return;
    }
    setOption(value);
    const v = grid.collectionView;
    v.editItem(v.currentItem);
    v.currentItem[column] = value;
    if (!v.currentItem['is_data_changed'][column]) {
      v.currentItem['is_data_changed'][column] = true;
    }
    v.commitEdit();
    if (isSetState) {
      setOption(value);
    }
    handlePushParam(context.item);
  };

  const getError = () => {
    return getErrorValidateWithId(msgValidate, context.item, column);
  };

  const getWorkHistories = params => {
    if (!context.item.foreman_user_id) {
      return null;
    }
    return WorkScheduleService.histories(fieldId, {
      ...params,
      field_id: fieldId,
      foreman_user_id: context.item.foreman_user_id,
      column,
    });
  };

  const handleOnchange = e => {
    if (isAbortedOrApproved) {
      return;
    }
    const { value } = e.target;
    handleUpdateData(value);
  };

  const renderDropdownWorkHistory = () => {
    if (!isShowHistory) {
      return null;
    }
    return (
      <Dropdown
        handleOnChange={data => handleUpdateData(data[column])}
        name={context.item[column]}
        value={context.item[column]}
        listForceReload={[context.item.foreman_user_id].toString()}
        callbackApi={getWorkHistories}
        responseKey='works'
        fieldValue={column}
        fieldName={column}
        isUseLoadMore={false}
        isSort={true}
      >
        <Dropdown.ButtonSelect readOnly={isAbortedOrApproved} tabKeyStatus={tabKeyStatus} />
        <Dropdown.List cssClass='dropdown__item--wide'>
          <Dropdown.RadioItems />
        </Dropdown.List>
      </Dropdown>
    );
  };

  return (
    <CellContent
      errorMsg={getError()}
      isDataChanged={_.get(context, `item.is_data_changed.${column}`)}
      errorTooltipId={`cell_${_.get(context, 'col.index')}_${_.get(
        context,
        'row.index'
      )}`}
      key={`${column}_${_.get(context, 'item.id')}`}
    >
      <input
        type='text'
        maxLength={maxLength}
        value={option}
        onChange={handleOnchange}
        disabled={isAbortedOrApproved}
        className='input-cell'
        tabIndex={tabKeyStatus}
        onFocus={() => {
          grid.select(context.row.index, context.col.index);
          grid.refresh();
        }}
      />
      {renderDropdownWorkHistory()}
    </CellContent>
  );
};

export default OptionTemplate;



// WEBPACK FOOTER //
// ./src/components/wijimo/templates/OptionTemplate.jsx